export enum ChatFormat {
  None = 'None',
  OpenAI = 'OpenAI',
  Gemini = 'Gemini',
  Anthropic = 'Anthropic',
  Mistral = 'Mistral',
  OTEL = 'OTEL',
}
